import React, { useEffect } from 'react';
import ExamFeaturePage from '../../features/specialty/editorial/ExamFeaturePage';

export default function LnatFeatureRoute() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ExamFeaturePage />;
}
